var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 2.6625C13.6866 2.2759 13.6866 1.6491 13.3 1.2625V1.2625C12.9134 0.875901 12.2866 0.875901 11.9 1.2625L7 6.1625L2.1 1.2625C1.7134 0.8759 1.0866 0.875901 0.7 1.2625V1.2625C0.313401 1.6491 0.313401 2.2759 0.7 2.6625L5.6 7.5625L0.7 12.4625C0.3134 12.8491 0.313401 13.4759 0.7 13.8625V13.8625C1.0866 14.2491 1.7134 14.2491 2.1 13.8625L7 8.9625L11.9 13.8625C12.2866 14.2491 12.9134 14.2491 13.3 13.8625V13.8625C13.6866 13.4759 13.6866 12.8491 13.3 12.4625L8.4 7.5625L13.3 2.6625Z",
    fill: "#E5E1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.85d35d304d69de05a6e0959642283926.svg";
export { ForwardRef as ReactComponent };